import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Divider from "../../../components/Decors/Divider/Divider";
import { Spinner } from "react-bootstrap";
import * as LeaderboardApi from "../../../network/leaderboard_api";
import { Leaderboard as LeaderboardModel } from "../../../models/leaderboard";
import styles from "../LeaderboardPage.module.scss";
import { FaCrown } from "react-icons/fa";

const Leaderboard = () => {
  const { t } = useTranslation();
  const [leaderboard, setLeaderboard] = useState<LeaderboardModel | null>(null);
  const [leaderboardLoading, setLeaderboardLoading] = useState(true);
  const [showLeaderboardLoadingError, setShowLeaderboardLoadingError] =
    useState(false);

  useEffect(() => {
    async function loadLeaderboard() {
      try {
        setShowLeaderboardLoadingError(false);
        setLeaderboardLoading(true);
        const leaderboardData = await LeaderboardApi.fetchLeaderboard();
        setLeaderboard(leaderboardData);
      } catch (error) {
        console.error(error);
        setShowLeaderboardLoadingError(true);
      } finally {
        setLeaderboardLoading(false);
      }
    }
    loadLeaderboard();
  }, []);

  return (
    <>
      <div className="title-block-container">
        <h1>{t("pages.leaderboard")}</h1>
        <Divider />
      </div>

      {leaderboardLoading && (
        <Spinner className="custom-spinner" animation="border" />
      )}

      {showLeaderboardLoadingError && <p>{t("error.refresh")}</p>}

      {leaderboard && (
        <>
          {/* Display Logged-in User's Rank */}
          <div className={styles["user-rank"]}>
            <h2 className="lightText">
              {t("leaderboard.myRank")}: {leaderboard.userRank}
            </h2>
          </div>

          {/* Display Top 10 Leaderboard */}
          <h3 className="lightText">{t("leaderboard.top10")}</h3>
          <table className={styles["leaderboard-table"]}>
            <thead>
              <tr>
                <th className={`${styles["leaderboard-rank"]}`}>
                  <FaCrown />
                </th>
                <th className={styles["leaderboard-user"]}>
                  {t("leaderboard.user")}
                </th>
                <th className={styles["leaderboard-level"]}>
                  {t("leaderboard.level")}
                </th>
                <th className={styles["leaderboard-xp"]}>
                  {t("leaderboard.xp")}
                </th>
              </tr>
            </thead>
            <tbody>
              {leaderboard.topUsers.map((user, index) => (
                <tr
                  key={index}
                  className={`${styles["leaderboard-rank"]} ${
                    index < 3 ? styles["top-rank"] : styles["bordered-rank"]
                  }`}
                >
                  <td>{index + 1}</td>
                  <td className={styles["leaderboard-user"]}>
                    <img
                      src={`${process.env.REACT_APP_API_URL}/images/collectibles/profileImages/${user.activeProfileImage}`}
                      alt={user.activeProfileImage}
                      width={40}
                      height={40}
                      className={styles["leaderboard-image"]}
                    />
                    {user.userName}
                  </td>
                  <td className={styles["leaderboard-level"]}>{user.level}</td>
                  <td className={styles["leaderboard-xp"]}>{user.xp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </>
  );
};

export default Leaderboard;
